module.exports = __webpack_public_path__ + "static/media/clients-01.a7153485.svg";